module.exports = __webpack_public_path__ + "img/banner3@2x.6960e969.png";